<div class="magic360-container">
  <a class="Magic360" [attr.data-options]="config" href="{{ firstLargeImage }}">
    <img src="{{ firstNormalImage }}" alt="Product Image" />
  </a>
</div>
